(function () {
  var MAP = { 'ð': 'd', 'þ': 'th', 'æ': 'ae', 'ö': 'o', 'ø': 'o', 'ß': 'ss' };
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[ðþæöøß]/g, function (c) { return MAP[c]; });
  }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function mark(text, q) {
    var n = norm(text), nq = norm(q), i = n.indexOf(nq);
    if (!nq || i < 0 || n.length !== String(text).length) return esc(text);
    return esc(text.slice(0, i)) + '<mark>' + esc(text.slice(i, i + q.length)) + '</mark>' + esc(text.slice(i + q.length));
  }
  function score(fields, terms) {
    var total = 0;
    for (var t = 0; t < terms.length; t++) {
      var term = terms[t], best = 0;
      for (var f = 0; f < fields.length; f++) {
        var v = fields[f][0], w = fields[f][1], i = v.indexOf(term);
        if (i < 0) continue;
        var s = i === 0 ? 3 : (/[\s\-\/(›]/.test(v.charAt(i - 1)) ? 2 : 1);
        if (s * w > best) best = s * w;
      }
      if (!best) return 0;
      total += best;
    }
    return total;
  }

  var INDEX = null, loading = null;
  function loadIndex() {
    if (INDEX) return Promise.resolve(INDEX);
    if (loading) return loading;
    // Cached for 10 minutes so products published mid-visit still show up.
    var key = 'pm-idx-v3', TTL = 10 * 60 * 1000;
    try {
      var c = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (c && Date.now() - c.t < TTL) { INDEX = prep(JSON.parse(c.d)); return Promise.resolve(INDEX); }
    } catch (e) {}
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    loading = fetch(root + 'collections/all?view=pm-index', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
      var d = JSON.parse(t); try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: t })); } catch (e) {}
      INDEX = prep(d); return INDEX;
    });
    return loading;
  }
  function prep(d) {
    return {
      p: d.p.map(function (x) { return { t: x[0], u: x[1], b: x[2], i: x[3], c: x[4], f: [[norm(x[0]), 4], [norm(x[2]), 3], [norm(x[6]), 4], [norm(x[4]), 1], [norm(x[5]), 1]] }; }),
      c: d.c.map(function (x) { return { t: x[0], u: x[1], i: x[2], n: x[3], f: [[norm(x[0]), 4], [norm(x[4]), 2]] }; }),
      b: d.b.map(function (x) { return { t: x[0], u: x[1], i: x[2], f: [[norm(x[0]), 4]] }; })
    };
  }
  function search(idx, q) {
    var terms = norm(q).split(/\s+/).filter(Boolean);
    function run(list, lim) {
      return list.map(function (x) { return { x: x, s: score(x.f, terms) }; }).filter(function (r) { return r.s > 0; })
        .sort(function (a, b) { return b.s - a.s || a.x.t.length - b.x.t.length; }).slice(0, lim).map(function (r) { return r.x; });
    }
    return { b: run(idx.b, 4), c: run(idx.c, 5), p: run(idx.p, 6) };
  }

  if (window.__pmSearch) return;
  window.__pmSearch = true;
  var instances = 0;

  // Header search modals: same engine as the homepage search, with the panel inside the modal.
  function headerRoots() {
    var L = window.pmSearchL;
    if (!L) return [];
    return Array.prototype.map.call(document.querySelectorAll('form.search-modal__form'), function (form, i) {
      var root = form.parentElement;
      var panel = document.createElement('div');
      panel.className = 'pm-sugg pm-sugg--modal'; panel.id = 'PmSuggHeader-' + i;
      panel.setAttribute('role', 'listbox'); panel.hidden = true;
      form.insertAdjacentElement('afterend', panel);
      return { root: root, form: form, panel: panel, L: L };
    });
  }
  var heroRoots = Array.prototype.map.call(document.querySelectorAll('[data-pm-search]'), function (root) {
    return { root: root, form: root.querySelector('form'), panel: root.querySelector('.pm-sugg'), L: JSON.parse(root.getAttribute('data-pm-search') || '{}') };
  });

  heroRoots.concat(headerRoots()).forEach(function (cfg) {
    var root = cfg.root, form = cfg.form, panel = cfg.panel, L = cfg.L;
    var input = form.querySelector('input[type="search"]');
    var pre = 'pm-opt-' + (instances++) + '-';
    var active = -1;

    function items() { return Array.prototype.slice.call(panel.querySelectorAll('[data-opt]')); }
    function setActive(i) {
      var list = items(); if (!list.length) return;
      active = (i + list.length) % list.length;
      list.forEach(function (el, k) { el.classList.toggle('is-active', k === active); el.setAttribute('aria-selected', k === active); });
      input.setAttribute('aria-activedescendant', list[active].id);
      list[active].scrollIntoView({ block: 'nearest' });
    }
    function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; }
    function open() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function thumb(src, cls) { return '<span class="' + cls + '">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '') + '</span>'; }

    function render(q, r) {
      var n = 0, html = '';
      if (!r.p.length && !r.c.length && !r.b.length) {
        html = '<div class="pm-sugg__empty">' + esc(L.none).replace('%q', '<strong>' + esc(q) + '</strong>') + '</div>';
      } else {
        var side = '';
        if (r.b.length) {
          side += '<p class="pm-sugg__label">' + esc(L.brands) + '</p><ul class="pm-sugg__list pm-sugg__brands" role="group">';
          r.b.forEach(function (x) {
            side += '<li><a id="' + pre + (n++) + '" data-opt role="option" class="pm-sugg__brand-row" href="' + esc(x.u) + '">' +
              thumb(x.i, 'pm-sugg__blogo') + '<span>' + mark(x.t, q) + '</span></a></li>';
          });
          side += '</ul>';
        }
        if (r.c.length) {
          side += '<p class="pm-sugg__label">' + esc(L.categories) + '</p><ul class="pm-sugg__list" role="group">';
          r.c.forEach(function (x) {
            side += '<li><a id="' + pre + (n++) + '" data-opt role="option" class="pm-sugg__link" href="' + esc(x.u) + '">' + mark(x.t, q) +
              (x.n ? ' <span class="pm-sugg__n">' + x.n + '</span>' : '') + '</a></li>';
          });
          side += '</ul>';
        }
        var main = '';
        if (r.p.length) {
          main += '<p class="pm-sugg__label">' + esc(L.products) + '</p><ul class="pm-sugg__list" role="group">';
          r.p.forEach(function (x) {
            main += '<li><a id="' + pre + (n++) + '" data-opt role="option" class="pm-sugg__prod" href="' + esc(x.u) + '">' + thumb(x.i, 'pm-sugg__img') +
              '<span class="pm-sugg__txt">' + (x.b ? '<span class="pm-sugg__brand">' + mark(x.b, q) + '</span>' : '') +
              '<span class="pm-sugg__title">' + mark(x.t, q) + '</span>' + (x.c ? '<span class="pm-sugg__cat">' + esc(x.c) + '</span>' : '') + '</span></a></li>';
          });
          main += '</ul>';
        }
        var two = main && side;
        html += '<div class="pm-sugg__cols' + (two ? '' : ' pm-sugg__cols--one') + '">';
        if (main) html += '<div class="pm-sugg__col pm-sugg__col--main">' + main + '</div>';
        if (side) html += '<div class="pm-sugg__col' + (two ? ' pm-sugg__col--side' : '') + '">' + side + '</div>';
        html += '</div>';
      }
      html += '<a id="' + pre + (n++) + '" data-opt role="option" class="pm-sugg__all" href="' + esc(form.action) + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">' + esc(L.all).replace('%q', '„' + esc(q) + '“') + ' <span aria-hidden="true">&rarr;</span></a>';
      panel.innerHTML = html; active = -1; open();
    }

    function update() {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      loadIndex().then(function (idx) { var cur = input.value.trim(); if (cur.length >= 2) render(cur, search(idx, cur)); }).catch(function () {});
    }
    input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false'); input.setAttribute('aria-controls', panel.id);
    input.addEventListener('focus', function () { loadIndex().catch(function () {}); if (input.value.trim().length >= 2) update(); });
    input.addEventListener('input', update);
    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); items()[active].click(); }
    });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
  });
})();
